import { useTranslation } from "react-i18next";
import { useEffect } from "react";

//#region src/hooks/form-validation/use-full-name-field-validation.ts
const useFullNameFieldValidation = (form) => {
	const { t } = useTranslation("pds");
	useEffect(() => {
		if (form.errors.firstName || form.errors.lastName) {
			form.setFieldError("name", t("common.formErrors.name.required"));
			return;
		}
		form.clearFieldError("name");
	}, [form, t]);
};

//#endregion
export { useFullNameFieldValidation };